/* eslint-disable */
import { ref, onMounted } from 'vue'
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import jwt_decode from "jwt-decode";
import axios from "axios";
import auth0 from "auth0-js";
import { getAuthCallbackUrl } from "../../Shared/authUrls";

const webAuth = new auth0.WebAuth({
  domain: process.env.VUE_APP_Auth_Domain,
  clientID: process.env.VUE_APP_Auth_Client_id,
});

export default {
  name: "login",
  setup() {
    let loadingBlock=ref(false)
    const authResult = ref({});
    const userid = ref("");
    const router = useRouter();
    const store = useStore();
    const username = ref("");
    const password = ref("");
    const errr = ref("");
    const patientemail = ref("")
    const patientpassword = ref("")
    const resultRoleId=ref([])
    const result = ref("");
    const defaultdate = ref("");
    const defaultTmile = ref("");
    const defaultStudy = ref("")
    const hasprivilege = ref(true);
    const inputType=ref("password")
		const visibleOn=ref(false)
    const errorBlock=ref(false)
    const checkRoldId=ref(false)
    const processingAuthCallback = ref(hasAuthHash())
    const privileges = ref({
      Forms: [""],
      Schedules: [""],
      Sites: [""],
      Subjects: [""],
      Visits: ["Visit Add Visit"]
    })
    let usersettingsUrl=ref(`${process.env.VUE_APP_Service_URL}/account-core/usersettings`);
    let baseurl = ref(process.env.VUE_APP_Service_URL);
    onMounted(async () => {
      let login = document.getElementsByClassName("login-patient")[0];
      if (login) {
        login.style.display = "none";
      }
      let loginTabPatient = document.getElementsByClassName("patient-tab-panels")[0]
      if (loginTabPatient) {
        loginTabPatient.style.backgroundColor = "#eaeaea"
      }
      await handleAuthCallback();
    })

    async function patientloginscreen() {
      router.push(`/PatientLoginScreen`);
    }

    function hasAuthHash() {
      const hash = window.location.hash || "";
      return hash.includes("access_token=") || hash.includes("id_token=") || hash.includes("error=");
    }

    function clearAuthHash() {
      window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
    }

    function showLoginError(message) {
      processingAuthCallback.value = false;
      errorBlock.value = true;
      errr.value = message || "Login failed. Please try again.";
      loadingBlock.value = false;
    }

    function handleAuthError(err) {
      const description = err && (err.description || err.errorDescription || err.message);

      if (description === "Wrong email or password.") {
        showLoginError("Invalid email or password.");
      } else if (description === "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.") {
        alert(description);
        processingAuthCallback.value = false;
        loadingBlock.value = false;
      } else if (description === "please change your password" || description === "Your password has been expired. Please reset your password.") {
        alert("Your password has been expired. Please reset your password.");
        processingAuthCallback.value = false;
        router.push(`/ResetPassword/${username.value}/reset/Webapp`);
        loadingBlock.value = false;
      } else if (description && description.toLowerCase().includes("state does not match")) {
        showLoginError("Authentication redirect mismatch. Please try signing in again.");
      } else {
        showLoginError(description || "Login failed. Please try again.");
      }
    }

    async function completeLogin(authresult) {
      authResult.value = authresult;
      await store.dispatch("loginuser", authresult);
      await loginAudit(authresult);
      await setdefaultstudy(authresult);
      await getUserSettings(authresult);
      errr.value = "";
      await setuserrole(authresult);
      if (checkRoldId.value == false) {
        await router.push(`/landingPage`);
      } else {
        await checkRole(authresult, resultRoleId.value);
      }
      loadingBlock.value = false;
    }

    async function handleAuthCallback() {
      if (!hasAuthHash()) return;

      errorBlock.value = false;
      errr.value = "";
      loadingBlock.value = true;
      processingAuthCallback.value = true;

      await new Promise((resolve) => {
        webAuth.parseHash({ hash: window.location.hash }, async (err, resultFromHash) => {
          clearAuthHash();
          if (err) {
            handleAuthError(err);
            resolve();
            return;
          }
          if (!resultFromHash || !resultFromHash.idToken) {
            showLoginError("Auth0 did not return a valid login session.");
            resolve();
            return;
          }
          try {
            await completeLogin(resultFromHash);
          } catch (loginError) {
            console.log(loginError);
            showLoginError("Login completed, but the application session could not be loaded.");
          } finally {
            resolve();
          }
        });
      });
    }

    // Pre-check: confirm the submitted username belongs to the submitted email
    // BEFORE ever calling Auth0. Password never leaves the browser for this
    // call, and Auth0's /oauth/token (webAuth.login) is only reached once
    // this passes.
    async function verifyIdentityBeforeAuth0(email, enteredUsername) {
      try {
        const res = await axios.get(
          `${baseurl.value}/account-core/user/isuserfound?emailId=${encodeURIComponent(email)}`
        );
        const storedUsername = (res.data && res.data.userName ? res.data.userName : "").trim();
        return storedUsername.length > 0 && storedUsername === enteredUsername;
      } catch (err) {
        console.log("Error verifying username before Auth0 login", err);
        return false;
      }
    }

    async function login() {
      errorBlock.value = false;
      errr.value = "";

      if (!userid.value) return showLoginError("The username field is required.");
      if (!username.value) return showLoginError("The email field is required.");
      if (!password.value) return showLoginError("The password field is required.");

      loadingBlock.value = true;

      const identityValid = await verifyIdentityBeforeAuth0(username.value.trim(), userid.value.trim());
      if (!identityValid) {
        showLoginError("Invalid username or email.");
        return;
      }

      webAuth.login({
        realm: process.env.VUE_APP_Auth_Realm || "Username-Password-Authentication",
        username: username.value.trim(),
        password: password.value,
        redirectUri: getAuthCallbackUrl(),
        responseType: "token id_token",
        scope: "openid profile email",
      }, (err) => {
        if (err) {
          console.log("Auth0 login error", err);
          handleAuthError(err);
        }
      });
    }
    async function patientloginClicked() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${baseurl.value}/verifypatientlogin?patientemail=${patientemail.value}&patientpassword=${patientpassword.value}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          result.value = res.data;
          if (result.value == true) {
            alert("Patient login success")
            router.push(`/PatientDashboard`);
          }
          else {
            alert("Login failed, please check the credentials!!")
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    async function checkRole(authresult,roleId) {
      const idtoken = authresult.idToken;
      await axios
        .get(
          `${baseurl.value}/account-core/roles/getbyid?guid=${roleId[0]}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            }
          },
        )
        .then(async (res) => {
          if (res.data.role_Name == 'F4P Role') {
            await router.push(`/f4pViewer`);
          }
          else {
            await router.push(`/landingPage`);
          }
          
        })
        .catch((err) => {
          console.log(err);
        });
    }
    async function getUserSettings(authresult) {
     
      const idtoken = authresult.idToken;
      const emailId = await jwt_decode(idtoken).email;
      await axios
        .get(
          `${usersettingsUrl.value}/getbyid?userId=${emailId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            }
          },
        )
        .then((res) => {
          if(res.data!='No data found'){
              defaultdate.value = res.data.dateFormat; 
            defaultTmile.value = res.data.timeFormat;                    
            if(defaultdate.value=="undefined" || defaultdate.value==null)
            {
              localStorage.setItem("dateformat","DD/MM/YYYY")
            }
            else{
            localStorage.setItem("dateformat",defaultdate.value)
            }

            if(defaultTmile.value=="undefined" || defaultTmile.value==null)
            {
              localStorage.setItem("timeformat","h:mm A")
            }
            else{
              localStorage.setItem("timeformat", defaultTmile.value);
            }
            if (res.data.localLanguage) {
              localStorage.setItem("lang", res.data.localLanguage);
            }
            if (res.data.graphType) {
              localStorage.setItem("graphType", res.data.graphType);
            }
          }
          else{
            checkRoldId.value=true
          }
          
        })
        .catch((err) => {
          console.log(err);
        });
    }
    async function passwordVisible()
      {
        visibleOn.value=!visibleOn.value
        if(visibleOn.value==true){
          inputType.value="text"
        }
        else inputType.value="password"
      } 
    async function getrollprevilage(array, authresult) {
      const idtoken = authresult.idToken;
      // let array = (store.getters.getRolesData).split(',');
      for (const eachrole of array){
        try {
        const res = await axios.get(
          `${baseurl.value}/account-core/roles/getscreenroleprivilegebyid?guid=${eachrole}`, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          if (res.data != "No ScreenRolePrivilege found") {
             await setrolesprivileges(res.data.screens, authresult);
          } else {
            await gotopages(authresult);
          }
        } catch (err) {
          console.log(err);
        }
      }

    }
    async function setrolesprivileges(data, authresult) {
      let privilegevalues = [];
      await getStudy(localStorage.getItem("study_id_ref"),authresult);
      const study = defaultStudy.value || {};
      if(study.isLocked !=true){
        await (data).forEach((screen) => {
          for (let j = 0; j < screen.controls.length; j++) {
            if (!privilegevalues.includes(screen.name + " " + screen.controls[j])) {
              privilegevalues.push(screen.name + " " + screen.controls[j]);
            }
          }
        });
      }
      else{
        await (data).forEach((screen) => {
          for (let j = 0; j < screen.controls.length; j++) {
            if (!privilegevalues.includes(screen.name + " " + screen.controls[j])) {
                    if(study.lockedItems && study.lockedItems["Visits"] == true){
                      if(privileges.value.Visits.includes(screen.name + " " + screen.controls[j])){
                      }else{
                        privilegevalues.push(screen.name + " " + screen.controls[j]);
                      }
                    }
                  }
            }
        });
      }   
      let userprivilegestring = privilegevalues.join();
      await store.dispatch("setrolesprivileges", `test test,${userprivilegestring}`);
      store.dispatch("loginuser", authresult);
      // router.push("/landingpage")
      await gotopages(authresult);
    }
    async function getStudy(studyId,authresult) {
      const idtoken = authresult.idToken;
      await axios.get(`${baseurl.value}/management/study/getbyid?id=${studyId}`, {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        }
      }).then((res)=>{
          defaultStudy.value = res.data;
        })
        .catch(err => console.log("error while getting default study", err));
      
    }
    async function gotopages(authresult) {
      const idtoken = authresult.idToken;
      const userid = jwt_decode(idtoken).sub;
      await axios
        .get(`${baseurl.value}/account-core/settings/getdashboard?UserID=${userid}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          store.dispatch("loginuser", authresult);
          let roles = store.getters.getRolesData;
          if (roles[0] == "bfc0a935-0441-405b-92a0-08d9af2e7771") {
              store.dispatch("setdefaultdashboard", "nursesummary");
            }
            else if(roles[0]=="f8d90da8-46d6-4265-9b24-0fc78deb4010" || roles[0]=="6c080321-2b3b-4c42-89ce-901cf0d8838e") {
              store.dispatch("setdefaultdashboard", "subjectdashboard");
            }
            else{
          if (res.data.defaultDashBoard && typeof res.data.defaultDashBoard != "undefined") {
            store.dispatch("setdefaultdashboard", res.data.defaultDashBoard);
          }
          else {
              store.dispatch("setdefaultdashboard", "home");
               
          }
        }

        })
        .catch((err) => {
          console.log(err);
          let roles = store.getters.getRolesData;
          if (roles[0] == "bfc0a935-0441-405b-92a0-08d9af2e7771") {
            store.dispatch("setdefaultdashboard", "nursesummary");
            router.push(`/nursesummary`);
          }
          else if(roles[0]=="f8d90da8-46d6-4265-9b24-0fc78deb4010" || roles[0]=="6c080321-2b3b-4c42-89ce-901cf0d8838e") {
              store.dispatch("setdefaultdashboard", "subjectdashboard");
              router.push(`/subjectdashboard`);
            }
          else {
            store.dispatch("setdefaultdashboard", "home");
            router.push(`/home`);
          }
        });
    }
    async function loginAudit(authresult) {
      const token = authresult.idToken;
      const emailId = await jwt_decode(token).email;
      const loginDate = new Date().toISOString();
      await axios
        .post(`${baseurl.value}/account-core/user/saveloginaudit`,
          {
            "userEmail": emailId,
            "logdetails": [
              {
                "action": "Log In",
                "date": loginDate,
                "time": loginDate
              }
            ]
          }
          ,
          {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          })
        .then((res) => {
          console.log("login audit res", res)
        })
        .catch((err) => {
          console.log(err);
        });
    }

    async function setdefaultstudy(authresult) {
      const idtoken = authresult.idToken;
      const userId = await jwt_decode(idtoken).email;
      console.log("userid " + userId);
      await axios
        .get(`${baseurl.value}/management/study/getdefaultstudy?id=` + userId, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.statusText == "No Content") {
            console.log("no default study");
          } else {
            store.dispatch("setStudyID", res.data.studyID);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    async function setuserrole(authresult) {
      const idtoken = authresult.idToken;
      const userid = (jwt_decode(idtoken).sub).trim();
      await axios
        .get(baseurl.value + "/account-core/user/getuserwithauthid?id=" + userid, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then(async (res) => {
          const userRoles = Array.isArray(res.data[0].role)
            ? res.data[0].role
            : [];
          let currentRole = userRoles.length > 0 ? userRoles[0] : "";

          try {
            const defaultSetupResponse = await axios.get(
              `${baseurl.value}/account-core/usersettings/defaultsetup`,
              {
                params: {
                  userId: jwt_decode(idtoken).email,
                },
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            );
            if (
              defaultSetupResponse.data &&
              defaultSetupResponse.data.defaultRole != null &&
              defaultSetupResponse.data.defaultRole !== ""
            ) {
              currentRole = defaultSetupResponse.data.defaultRole;
            }
          } catch (err) {
            console.log("Error loading default role", err);
          }

          const selectedRole = currentRole ? [currentRole] : [];
          store.dispatch("setroles", selectedRole);
          resultRoleId.value = selectedRole;
          await getrollprevilage(selectedRole, authresult);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    async function getdefaultlanguage(authresult) {
      await getUserSettings(authresult);
    }
    function testonmount() {
      store.dispatch("setrolesprivileges", 'test test,');
      store.dispatch("setNavbar", true);
    }

    onMounted(testonmount)
    return {
      login,
      authResult,
      userid,
      username,
      password,
      errr,
      defaultdate,
      defaultTmile,
      patientemail,
      patientpassword,
      result,
      usersettingsUrl,
      visibleOn,
		  inputType,
      loadingBlock,
      errorBlock,
      processingAuthCallback,
      defaultStudy,
      privileges,
      checkRoldId,
      resultRoleId,
      setuserrole,
      patientloginscreen,
      getdefaultlanguage,
      setdefaultstudy,
      patientloginClicked,
      passwordVisible,
      getUserSettings,
      getStudy,
      checkRole
    };
  },
};
